import {
  CloseButton,
  CrudMode,
  DELETE_WARNING,
  DropDownMenu,
  ListContext,
  ListContextValue,
  MenuItemType,
  Stack,
  Typography,
  UpdateButton,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { DataModelInformation, SubmitButton } from "components";
import { DataModelEnum, Permission, PermissionAction, StudentScholarship } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const StudentScholarshipPageHeader = (props: {
  rootPermission: Permission;
  handle: string;
  crudMode: CrudMode;
  fetch: (id: number) => void;
  reroute: (id: number, crudMode: CrudMode) => void;
  scholarship: StudentScholarship;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const id = props.scholarship.id;

  const save = (scholarship: StudentScholarship) => {
    props.setValidationErrors({});

    if (id > 0) {
      ApiService.studentScholarships
        .saveUpdate(scholarship)
        .then(() => {
          props.reroute(id, "view");
          props.fetch(id);
          listContext.loadList?.();
          dispatch(setAppToast(newToast("success")));
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.data);
        });
    } else {
      ApiService.studentScholarships
        .saveCreate(scholarship)
        .then((response) => {
          const id = response;
          props.reroute(id, "view");
          props.fetch(id);
          listContext.loadList?.();
          dispatch(setAppToast(newToast("success")));
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.data);
        });
    }
  };

  const postDelete = (id: number) => {
    if (window.confirm(DELETE_WARNING)) {
      ApiService.studentScholarships.delete(id).then(() => {
        navigate("../");
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      });
    }
  };

  const menuItems: MenuItemType[] = [];
  if (id > 0) {
    if (isAuthorized(props.rootPermission, PermissionAction.Delete))
      menuItems.push({
        label: <Typography color="error">Delete</Typography>,
        action: () => postDelete(id),
      });
  }

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        <Typography variant="inherit">
          {id === 0 ? "New" : ""} {props.handle}
        </Typography>
        {menuItems.length > 0 && <DropDownMenu menuItems={menuItems} />}
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        {id > 0 && <DataModelInformation dataModelType={DataModelEnum.StudentScholarship} dataModelId={id} />}

        <CloseButton confirm={props.unsavedChanges} />

        {props.crudMode === "view" && isAuthorized(props.rootPermission, PermissionAction.Update) && (
          <UpdateButton onClick={() => props.reroute(id, "edit")} />
        )}

        {props.crudMode === "edit" && (
          <SubmitButton onClick={() => save(props.scholarship!)} disabled={!props.unsavedChanges} />
        )}
      </Stack>
    </Stack>
  );
};
